import React, { useContext, useEffect, useRef, useState } from "react";
import AdvertisementCard from "./AdvertisementCard";
import { ErrorMessage, Form, Formik } from "formik";
import style from "./AdvertisementCard.module.css";
import { LuEye } from "react-icons/lu";
import { PiShareFat, PiInfoLight } from "react-icons/pi";
import { MdDownloadDone, MdOutlineShoppingCart, MdEdit } from "react-icons/md";
import { Line } from "react-chartjs-2";
import { toast } from "react-toastify";
import { AdvertisementApi } from "../../../App/api/Advertisement.apis";
import Lable from "../../../Components/Lable";
import PromoImg from "../../../Assets/images/dummy.jpg";
import SidebarField from "../../../Components/SidebarField";
import LoaderContext from "../../../Components/loader";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
function PromoManagement({meta}) {
  const [adData, setAdData] = useState([]);

  const { handleLoading } = useContext(LoaderContext);
  const chartRef = useRef(null);
  const [isAdvertisementModel, setIsAdvertisementModel] = useState(false);
  const [singleAdd, setSingleAdd] = useState({
    _id: 1,
    image: "",
    advertisement_for: "product",
    product: "",
    products: "",
    start_date: "",
    end_date: "",
    duration: 0,
    audience_type: "",
    target_audience_age: 0,
    location_radius: 0,
    gender: "",
    advertisement_budget: 0,
    advertisement_tax: 0,
    advertise_views: 0,
    ordered_by_advertise: 0,
    addToCart_count: 0,
    share: 0,
  });

  const [adPagination, setAdPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });
  const handlePagination = (data) => {
    // console.log(data);
    if (data.clearPagination) {
      setAdPagination(data.clearPagination);
      return;
    }
    setAdPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {

        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const beforeMount = async () => {
    try {
      //get all advertisement details
      const resAddData = await AdvertisementApi.getAllAdvertisement(
        adPagination
      );
      // console.log("all Advertisement", resAddData.data.data?.advertisements);
      setAdData(resAddData.data.data?.advertisements);
      // handlePromoForOption()
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleLoading(true);
    beforeMount();
    handleLoading(false);
  }, []);

  const handleEditOpen = (value) => {
    setIsAdvertisementModel(true);
    setSingleAdd(value);
  };


  const handleClose = () => {
    setIsAdvertisementModel(false);
  };
  const data = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Views",
        data: [35000, 22000, 80000, 15000, 56000, 11000, 40000],
        fill: false,
        backgroundColor: "rgba(10,255,10,0.4)",
        borderColor: "rgba(10,255,10,1)",
      },
      {
        label: "Orders",
        data: [32000, 32000, 10000, 95000, 19000, 11800, 10000],
        fill: false,
        backgroundColor: "rgba(255, 0, 0, 0.4)",
        borderColor: "rgba(255, 0, 0,1)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
      },
      y: {
        display: true,
      },
    },
  };

  
  return (
    <>
      <CommonLayout/>
      <div className="flex flex-wrap p-4">
        {adData.length
          ? adData?.map((data, i) => (
              <AdvertisementCard
                adData={data}
                key={i}
                handleEditOpen={handleEditOpen}
                handleClose={handleClose}
                // handleDelete={handleDeleteOffer}
              />
            ))
          : "No advertise is Created yet"}

        {isAdvertisementModel && (
          <Formik
            initialValues={{
              image: singleAdd?.image || "",
              // title: singleAdd?.title || "",
              advertisement_for: singleAdd?.advertisement_for || "product",
              product: singleAdd?.product || null,
              products: singleAdd?.products || "",
              start_date: singleAdd?.start_date || "",
              end_date: singleAdd?.end_date || "",
              duration: singleAdd?.duration || 0,
              audience_type: singleAdd?.audience_type || "",
              target_audience_age: singleAdd?.target_audience_age || 0,
              location_radius: singleAdd?.location_radius || 0,
              gender: singleAdd?.gender || "All",
              // audience_count: singleAdd?.audience_count || 9,
              advertisement_budget: singleAdd?.advertisement_budget || 0,
              advertisement_tax: singleAdd?.advertisement_tax || 50,
              advertise_views: singleAdd?.advertise_views || 0,
              ordered_by_advertise: singleAdd?.ordered_by_advertise || 0,
              addToCart_count: singleAdd?.addToCart_count || 0,
              share: singleAdd?.share || 0,
            }}
            // onSubmit={handleSubmit}
          >
            {({ handleChange, setFieldValue, values, handleSubmit }) => (
              <Form>
                <SidebarField
                  handleClose={handleClose}
                  title_style="text-red-500 text-2xl"
                  title={"Advertisement Details"}
                >
                  <div className="p-2 text-lg">
                    <div className="relative h-fit w-[95%] shadow-xl rounded-xl m-auto">
                      <label
                        htmlFor="image-upload"
                        className="absolute right-1 top-1 p-2 bg-buttonColor rounded-full cursor-pointer text-secondaryColor"
                      ></label>
                      {values.image ? (
                        <img
                          src={values.image}
                          alt="Promo"
                          style={{ borderRadius: "1rem", objectFit: "cover" }}
                        />
                      ) : (
                        <img
                          src={PromoImg}
                          alt="Promo Not Found"
                          style={{ borderRadius: "1rem", objectFit: "cover" }}
                        />
                      )}
                    </div>
                    <div className="">
                      {values.advertisement_for &&
                        values.advertisement_for == "product" && (
                          <div className="mt-3 mb-4 border-b">
                            <Lable
                              lable={`${values.advertisement_for} name: `}
                            />
                            <span className="text-gray-400">
                              {values.products?.name}
                            </span>
                          </div>
                        )}

                      <div className="mb-4 border-b">
                        <div className="flex ">
                          <Lable lable="Advertisement Dates" />
                        </div>
                        <div className="flex justify-between">
                          <h2 className="text-lg">Start Date:</h2>
                          <h2 className="text-lg">
                            {new Date(values.start_date).toLocaleDateString()}
                          </h2>
                        </div>
                        <div className="flex justify-between">
                          <h2 className="text-lg">Exp Date:</h2>
                          <h2 className="text-lg">
                            {new Date(values.end_date).toLocaleDateString()}
                          </h2>
                        </div>
                      </div>
                      <div className="flex justify-between gap-2 mb-4">
                        <div className="w-[100%]">
                          <div className="flex justify-between pb-1 border-b">
                            <h2 className="text-lg">Audience Type: </h2>
                            <h2 className="text-lg">{values.audience_type}</h2>
                          </div>
                        </div>
                      </div>
                      {values.audience_type == "Own Audience" && (
                        <div className="mb-2">
                          <Lable lable="preferred Audience" />
                          <div className="flex flex-col  pb-1 border-b ">
                            {/* Age */}
                            <div className="flex justify-between mb-2">
                              <h2 className="text-lg">Age:</h2>
                              <h2 className="text-lg">
                                {values.target_audience_age}
                              </h2>
                            </div>
                            {/* location radius */}
                            <div className="flex justify-between mb-2">
                              <h2 className="text-lg">Location Radius:</h2>
                              <h2 className="text-lg">
                                {values.location_radius}KM
                              </h2>
                            </div>
                            {/* gender*/}
                            <div className="flex justify-between mb-2">
                              <h2 className="text-lg">Gender:</h2>
                              <h2 className="text-lg">{values.gender}</h2>
                            </div>
                            <div />
                          </div>
                        </div>
                      )}
                      <Lable lable="Cost Calculation" />
                      <div className="flex justify-between">
                        <h2 className="text-lg">TAX:</h2>
                        <p>${values.advertisement_tax}</p>
                      </div>
                      <div className="flex justify-between pb-1 border-b">
                        <h2 className="text-lg">Daily Budget:</h2>
                        <p>${values.advertisement_budget}</p>
                      </div>
                      <div className="flex justify-between">
                        <h2 className="text-lg">Total Cost:</h2>
                        <p>
                          $
                          {values?.advertisement_budget +
                            values?.advertisement_tax}
                        </p>
                      </div>

                      {singleAdd?._id ? (
                        <div className="flex justify-between px-4 py-2">
                          <span className="flex flex-col items-center justify-center">
                            <LuEye fontSize={"1.5rem"} />
                            <span>{singleAdd?.advertise_views}</span>
                          </span>
                          <span className="flex flex-col items-center justify-center">
                            <MdDownloadDone fontSize={"1.5rem"} />
                            <span>{singleAdd?.ordered_by_advertise}</span>
                          </span>
                          <span className="flex flex-col items-center justify-center">
                            <MdOutlineShoppingCart fontSize={"1.5rem"} />
                            <span>{singleAdd?.addToCart_count}</span>
                          </span>
                          <span className="flex flex-col items-center justify-center">
                            <PiShareFat fontSize={"1.5rem"} />
                            <span>{singleAdd?.share}</span>
                          </span>
                        </div>
                      ) : null}
                      {/* More icons here */}
                    </div>
                    {singleAdd?.product ? (
                      <>
                        <hr className="py-1" />
                        <div style={{ height: "10rem" }}>
                          <Line
                            ref={chartRef}
                            data={data}
                            options={options}
                            className="p-2"
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                </SidebarField>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </>
  );
}

export default PromoManagement;
